module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dof-diamond-tab weex-ct weex-div",
    attrs: {
      "weex-type": "div",
      "data-evt-touchend": ""
    },
    on: {
      "touchend": function($event) {
        $event.stopPropagation();
        return _vm.touchEnd($event)
      }
    }
  }, [_c('div', {
    staticClass: " weex-ct weex-div",
    class: ['dof-diamond-tab-box', _vm.isFlexible && 'flex-1'],
    style: ({
      borderRadius: _vm.borderRadius
    }),
    attrs: {
      "weex-type": "div"
    }
  }, _vm._l((_vm._tabData), function(tab, i) {
    return _c('div', {
      key: i,
      staticClass: " weex-ct weex-div",
      class: ['dof-diamond-tab-item', _vm.isFlexible && 'flex-1'],
      style: ({
        left: _vm._px2rem(-i + 'px', 75)
      }),
      attrs: {
        "weex-type": "div",
        "data-evt-click": "",
        "data-evt-touchstart": ""
      },
      on: {
        "click": _vm.$stopOuterA,
        "touchstart": function($event) {
          $event.stopPropagation();
          return _vm.touchTabItem(i)
        },
        "weex$tap": function($event) {
          $event.stopPropagation();
          return _vm.clickTabItem(i)
        }
      }
    }, [_c('div', {
      staticClass: " weex-ct weex-div",
      class: [
        'dof-diamond-tab-item-label',
        i === 0 ? 'first-tab' : '',
        i === _vm.dataLen - 1 ? 'last-tab' : '',
        _vm.isFlexible && 'flex-1'
      ],
      style: ({
        'border-color': _vm.tabActive === i ? _vm.activeBorderColor : _vm.borderColor,
        'background-color': _vm.touchActive === i ? _vm.touchColor : _vm.bgColor,
        height: _vm._px2rem(_vm.itemHeight + 'px', 75),
        'border-top-left-radius': i === 0 ? _vm.borderRadius : '0px',
        'border-bottom-left-radius': i === 0 ? _vm.borderRadius : '0px',
        'border-top-right-radius': i === _vm.dataLen - 1 ? _vm.borderRadius : '0px',
        'border-bottom-right-radius': i === _vm.dataLen - 1 ? _vm.borderRadius : '0px'
      }),
      attrs: {
        "weex-type": "div"
      }
    }, [_c('p', {
      staticClass: "label-text weex-el weex-text",
      style: ({
        fontSize: _vm._px2rem(_vm.textFontSize, 75),
        color: _vm.tabActive === i || _vm.touchActive === i ? _vm.activeTextColor : _vm.textColor
      }),
      attrs: {
        "weex-type": "text"
      }
    }, [_vm._v(_vm._s(tab.label.length > _vm.labelMaxLen ? tab.label.slice(0, _vm.labelMaxLen) + '...' : tab.label))])]), _vm._v(" "), (i !== _vm.dataLen - 1) ? _c('div', {
      staticClass: "tabLine weex-ct weex-div",
      style: (_vm._px2rem(Object.assign({
        backgroundColor: _vm.bgColor
      }, _vm.tabLineStyle), 75)),
      attrs: {
        "weex-type": "div"
      }
    }, [_c('div', {
      staticClass: "tabLineMaskDown weex-ct weex-div",
      style: (_vm._px2rem(Object.assign({
        'background-color': _vm.touchActive - 1 === i ? _vm.touchColor : _vm.bgColor
      }, _vm.maskStyle), 75)),
      attrs: {
        "weex-type": "div"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "tabLineMaskUp weex-ct weex-div",
      style: (_vm._px2rem(Object.assign({
        'background-color': _vm.touchActive === i ? _vm.touchColor : _vm.bgColor
      }, _vm.maskStyle), 75)),
      attrs: {
        "weex-type": "div"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "border-top weex-ct weex-div",
      style: ({
        'border-color': _vm.tabActive === i ? _vm.activeBorderColor : _vm.borderColor
      }),
      attrs: {
        "weex-type": "div"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "border-bottom weex-ct weex-div",
      style: (_vm._px2rem(Object.assign({
        'background-color': _vm.tabActive - 1 === i ? _vm.activeBorderColor : _vm.borderColor
      }), 75)),
      attrs: {
        "weex-type": "div"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "slash weex-ct weex-div",
      style: ({
        left: _vm._px2rem(_vm.isAndroid ? _vm.itemHeight / 8 : _vm.itemHeight / 8 - 1 + 'px', 75),
        transform: _vm._px2rem(_vm.isAndroid ? 'translateX(-1px) rotate(13deg)' : 'rotate(13deg)', 75),
        width: _vm._px2rem(_vm.isAndroid ? '2.5px' : '2px', 75),
        'background-color': _vm.tabActive === i || _vm.tabActive - 1 === i ? _vm.activeBorderColor : 'transparent'
      }),
      attrs: {
        "weex-type": "div"
      }
    })]) : _vm._e()])
  }), 0)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7efcdc57", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7efcdc57","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/dof-diamond-tab/index.vue
// module id = 635
// module chunks = 0 1